import { useState } from 'react';

const STORAGE_PREFIX = 'enrichment-card-open:';

/** Cards start collapsed; storage can be blocked or absent, and then they just do. */
function readOpen(id: string): boolean {
  try {
    return window.localStorage.getItem(STORAGE_PREFIX + id) === '1';
  } catch {
    return false;
  }
}

function writeOpen(id: string, open: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + id, open ? '1' : '0');
  } catch {
    // Remembering is a convenience; the toggle still works without it.
  }
}

export interface CollapsibleCardProps {
  /** Stable key the open state is remembered under. */
  id: string;
  title: string;
  /** Pending items; hidden at zero. */
  count?: number;
  /** A running job's one-line state, kept visible while collapsed. */
  status?: string | null;
  children: React.ReactNode;
}

export function CollapsibleCard(props: CollapsibleCardProps): React.JSX.Element {
  const [open, setOpen] = useState(() => readOpen(props.id));
  const toggle = (): void => {
    writeOpen(props.id, !open);
    setOpen(!open);
  };

  return (
    <section className="card enrichment-card collapsible-card">
      <button className="collapsible-head" type="button" aria-expanded={open} onClick={toggle}>
        <span className="collapsible-title">{props.title}</span>
        {props.count !== undefined && props.count > 0 && (
          <span className="collapsible-count">{props.count}</span>
        )}
        {props.status !== undefined && props.status !== null && (
          <span className="collapsible-status">{props.status}</span>
        )}
        <span className="collapsible-chevron" aria-hidden="true" />
      </button>
      {open && props.children}
    </section>
  );
}
